import Vue from 'vue';
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';
import Wechat from 'vue-wechat';

import App from './App.vue';
import router from './router';
import store from './stores';
require('./directives.js');

import { api } from './api.service'

import './registerServiceWorker';

import 'material-design-icons-iconfont/dist/material-design-icons.css'; // Ensure you are using css-loader

import Vuetify from 'vuetify';
import colors from 'vuetify/es5/util/colors';
require('vuetify/dist/vuetify.min.css');

import en from './locale/en.ts';
import es from './locale/es.ts';
import ko from './locale/ko.ts';
import zhHans from './locale/zh-Hans.ts';
import zhTW from './locale/zh-tw.ts';
import fr from './locale/fr.ts';
import vi from './locale/vi.ts';
import ar from './locale/ar.ts';
import th from './locale/th.ts';
import { VuetifyLazyImagePlugin } from "vuetify-lazy-image";

import VeeValidate from 'vee-validate';
import VueI18n from 'vue-i18n';
import enErrors from 'vee-validate/dist/locale/en';
import zhHansErrors from 'vee-validate/dist/locale/zh_CN';

import VueTheMask from 'vue-the-mask';
import VueMeta from 'vue-meta';

let isChrome = false;
let chromeVersion = 0;

try {
  if (navigator.userAgent && /Chrome/.test(navigator.userAgent)) {
    isChrome = true;
    const match = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
    chromeVersion = match ? parseInt(match[2], 10) : 0;
  }
} catch (error) {
  console.error("An error occurred while checking for Chrome:", error);
}

Vue.use(VueTheMask);

Vue.use(VueI18n);

function getStoreDefaultLang() {
  let storeLangs = [];
  try {
    const storeData = JSON.parse(localStorage.getItem('store'));
    if (storeData && Array.isArray(storeData.languages)) {
      storeLangs = storeData.languages;
    }
  } catch (e) {}
  const defaultLangObj = storeLangs.find(l => l.selected) || storeLangs[0];
  return defaultLangObj ? defaultLangObj.code : 'en';
}
function getInitialLang() {
  const userLangSelected = localStorage.getItem('langManuallySelected');
  const userLang = localStorage.getItem('lang');
  if (userLangSelected === 'true' && userLang) {
    return userLang;
  }
  return getStoreDefaultLang();
}

let defaultLang = getInitialLang();
const i18n = new VueI18n({
  locale: defaultLang,
  messages: {
    en,
    zhHans,
    zhTW,
    'zh-TW': zhTW,
    zh: zhHans,
    fr,
    ko,
    es,
    vi,
    ar,
    th
  }
});

function setAppLanguage(lang) {
  i18n.locale = lang;
  if (Vue.prototype.$vuetify) {
    Vue.prototype.$vuetify.lang.current = lang;
  }
}

import viErrors from 'vee-validate/dist/locale/vi';
Vue.use(VeeValidate, {
  i18nRootKey: "validations", // customize the root path for validation messages.
  i18n,
  dictionary: {
    en: enErrors,
    zhHans: zhHansErrors,
    vi: viErrors
  }
});

let defaultTheme = {
  primary: "#1e9d84",
  secondary: "#424242",
  accent: "#82B1FF",
  error: "#e63d2c",
  info: "#2196F3",
  success: "#4CAF50",
  warning: "#FFC107",
  normal: "#424242"
};

Vue.use(Vuetify, {
  options: {
    customProperties: true
  },
  theme: defaultTheme,
  iconfont: "md",
  lang: {
    locales: { en, zhHans, zhTW, 'zh-TW': zhTW, zh: zhHans, fr, ko, es, ar, th, vi },
    current: defaultLang
  }
});

Vue.use(VuetifyLazyImagePlugin);
Vue.use(Wechat);

Vue.wechat.config({
  appId: "wx5f89682208cf2e87",
  timestamp: "1567086662667",
  nonceStr: "VDDD7G9VEQPYKEMR",
  signature: "0505918c4aaef4105297578f58e3864f7097fa55"
});
Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: "AIzaSyD07j30821s5ZA1SnZZuh4iNXws9wonux0"
});

Vue.use(VeeValidate);


Vue.filter("phone", function(phone) {
  return phone
    .replace(/[^0-9]/g, "")
    .replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
});

Vue.config.productionTip = false;
Vue.config.environment = process.env.NODE_ENV;

store.$api = api;
store.$router = router;
store.$store = store;

window.runActionsMap = {};
const threshold = 100;
const name = "";
const ignoreName = "";
window.logGetter = (getter) => {
  console.log("running logGetter", getter);
  // if (!(`${getter}` in runActionsMap))
  //   runActionsMap[getter] = 1
  // else
  //   runActionsMap[getter]++
  //
  // if (runActionsMap[getter] >= threshold && (!name || getter.includes(name)) &&  (!ignoreName || !getter.includes(ignoreName)))
  //   console.warn(`running: ${getter}\nOccurance: ${runActionsMap[getter]}\n`);
};

/* By extending the Vue prototype with a new $bus property
  * we can easily access our global event bus from any child component.
  * We can use the code below to add additional properties into Vue, if needed
  */
const EventBus = new Vue();
Object.defineProperties(Vue.prototype, {
  $bus: {
    get: function() {
      return EventBus;
    }
  }
});

Vue.use({
  install() {
    Vue.prototype.$api = api;
    Vue.prototype.$vuetify.defaultTheme = defaultTheme;
    Vue.prototype.$i18nPointer = i18n;
    Vue.prototype.$store = store;
  }
});


Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});

// DEV-11345: Sentry (~1 MB pre-minify with session replay) used to sit in chunk-vendors and be
// downloaded before first render even though it's only initialized after it. It now loads in
// its own chunk at that same moment; errors from before it arrives are queued, not dropped.
let Sentry = null;
const earlySentryErrors = [];
function captureToSentry(err, info) {
  Sentry.captureException(err);
  if (info) {
    Sentry.setExtra("vueComponent", info);
  }
}
function initSentry() {
  import(/* webpackChunkName: "sentry" */ "@sentry/vue").then((SentryModule) => {
    Sentry = SentryModule;
    startSentry();
    earlySentryErrors.splice(0).forEach(([err, info]) => captureToSentry(err, info));
  }).catch((e) => console.error('Failed to load Sentry', e));
}
function startSentry() {
  Sentry.init({
    dsn: "https://9b59f2b7778ec56801b119dce74cc3e7@o4506712481660928.ingest.sentry.io/4506791607336960",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false
      })
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets:['localhost', /^\//],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    debug: false,
    beforeSend: (event, hint) => {
      try {
        const msg = hint && hint.originalException && hint.originalException.message

        if (msg && msg.includes('_AutofillCallbackHandler')) {
          return null;
        }
        if (msg && msg === 'Network Error') {
          return null;
        }
        if (msg && msg.includes('[vee-validate] Validating a non-existent field')) {
          return null;
        }
        if (
          hint &&
          hint.originalException &&
          hint.originalException.stack
        ) {
          const stackTraceLines = hint.originalException.stack.split("\n");
          const isFromNodeModules = stackTraceLines.some((line) =>
            line.includes("node_modules")
          );

          if (isFromNodeModules) {
            console.error("An error occurred while checking for Chrome:", error);
          }
        }
        if (
          event &&
          (event.sdk || event.level) &&
          ((Sentry && Sentry.Severity && (event.level !== Sentry.Severity.Error &&
            event.level !== Sentry.Severity.Fatal)) ||
            (event.sdk && event.sdk.name === "sentry.javascript"))
        ) {
          return null;
        }
        return event;
      } catch(e) {
        console.log(e)
      }
    }
  })
}

Vue.config.errorHandler = function(err, vm, info) {
  if (Sentry) {
    captureToSentry(err, info);
  } else {
    earlySentryErrors.push([err, info]);
  }
  console.error(err, vm, info);
};


function mountApp() {
  new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App)
  }).$mount("#app");
  // Init Sentry after first paint so it doesn't block the critical render path
  setTimeout(initSentry, 0);
}

const storeData = JSON.parse(localStorage.getItem('store'));
if (!storeData || !storeData.languages) {
  store.dispatch('fetchStore', { gid: localStorage.getItem('gid'), sid: localStorage.getItem('sid') })
    .then(() => {
      const storeObj = store.getters.getStore;
      let lang = 'en';

      let displayLanguages = (storeObj && storeObj.settings && storeObj.settings.orderSettings && storeObj.settings.orderSettings.displayLanguages);
      if (!displayLanguages || !Array.isArray(displayLanguages) || displayLanguages.length === 0) {
        displayLanguages = (storeObj && storeObj.settings && storeObj.settings.owaSettings && storeObj.settings.owaSettings.displayLanguages);
      }

      if (displayLanguages && Array.isArray(displayLanguages) && displayLanguages.length > 0) {
        lang = displayLanguages[0];
      } else {
        const langs = (storeObj && storeObj.languages) ? storeObj.languages : [];
        const defaultLangObj = langs.find(function(l){return l.selected}) || langs[0];
        lang = defaultLangObj ? defaultLangObj.code : 'en';
      }
      setAppLanguage(lang);
    })
    .catch(() => {})
    .finally(() => {
      mountApp();
    });
} else {
  mountApp();
}
store.watch(
  function(state, getters) {
    return {
      storeLanguages: getters.getStoreLanguages,
      store: getters.getStore
    };
  },
  function(data) {
    const userLangSelected = localStorage.getItem('langManuallySelected');
    const userLang = localStorage.getItem('lang');
    if (userLangSelected === 'true' && userLang) {
      setAppLanguage(userLang);
      return;
    }
    
    const store = data.store;
    if (!store) return;
    let displayLanguages = (store && store.settings && store.settings.orderSettings && store.settings.orderSettings.displayLanguages);
    if (!displayLanguages || !Array.isArray(displayLanguages) || displayLanguages.length === 0) {
      displayLanguages = (store && store.settings && store.settings.owaSettings && store.settings.owaSettings.displayLanguages);
    }
    
    if (displayLanguages && Array.isArray(displayLanguages) && displayLanguages.length > 0) {
      setAppLanguage(displayLanguages[0]);
      return;
    }
    const langs = data.storeLanguages;
    if (langs && langs.length) {
      const defaultLangObj = langs.find(function(l){return l.selected}) || langs[0];
      const lang = defaultLangObj ? defaultLangObj.code : 'en';
      setAppLanguage(lang);
    }
  }
)